import _ from "underscore";
import templateUrl from 'servicestack/automations/recipes-list.htm'
import AutoQuery from 'servicestack/auto-query/auto-query'
import basicController from 'servicestack/basic.controller.properties'
import resolve from 'ioc/resolve'
import AutomationPrompt from "servicestack/automations/automation-prompt";
import ServiceBus from "servicestack/service-bus";

class RecipesListController {
    constructor($rootScope) { 
        let $ctrl = this;
        basicController($ctrl);
		$ctrl.bus = new ServiceBus();
    }
	$onInit() {
		const $ctrl = this;
		$ctrl.query = new AutoQuery({
			url: 'QueryRecipes.json',
			autoLoad: true,
			pageSize: 1000,
			scrollTop: false,
			onLoaded: function (response) {
				response.results.forEach(function (res) {
					res.ingredients = JSON.parse(res.ingredients);
					res.searchText = res.ingredients.map(n => n.word).join(" ");
				});
				$ctrl.recipes = response.results;
				$ctrl.allRecipes = response.results;
			}
			//scrub: ({ data }) =>
			//	(data.results = data.results.map(
			//		p => p.ingredients = JSON.parse(p.ingredients)
			//	))
		});
		$ctrl.recipeTags = [
			{
				title: 'All',
				icon: 'tags'
			},
			{
				title: 'Status Change',
				icon: 'bars'
			},
			{
				title: 'Notifications',
				icon: 'envelope-o'
			},
			{
				title: 'Registration',
				icon: 'user-circle-o'
			},
			{
				title: 'Forms',
				icon: 'pencil-square-o'
			},
			{
				title: 'Shipments',
				icon: 'truck'
			},
			{
				title: 'Shopping',
				icon: 'shopping-cart'
			},
			{
				title: 'Activities',
				icon: 'calendar'
			}
		];
	}
	filterRecipes(filter) {
		const $ctrl = this;
		if (filter == 'All') {
			return $ctrl.recipes = $ctrl.allRecipes;
		}
		$ctrl.recipes = $ctrl.allRecipes.filter(f => f.tags.indexOf(filter) >= 0);
	}
	filterRecipeSearch() {
		const $ctrl = this;
		$ctrl.recipes = $ctrl.allRecipes.filter(f => f.tags.toLowerCase().includes($ctrl.recipeSearch.toLowerCase()) || f.searchText.toLowerCase().includes($ctrl.recipeSearch.toLowerCase()) ||  f.actionType.toLowerCase().includes($ctrl.recipeSearch.toLowerCase()) || f.eventType.toLowerCase().includes($ctrl.recipeSearch.toLowerCase()));
	}
	create(recipe) {
		const $ctrl = this;
		AutomationPrompt.open({recipe: recipe}).then(() => $ctrl.query.load());
	}
}

let RecipesList = {
    bindings: {
    },
    controller: RecipesListController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
}

export default RecipesList